import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-primary/10 mt-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-20">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-12">
          <div>
            <img
              src="/images/logo.png"
              alt="Dream Entertainment"
              className="h-14 w-auto"
              data-testid="footer-logo"
            />
            <p className="text-sm text-muted-foreground mt-6 leading-relaxed max-w-xs">
              Premier DJ &amp; event experiences for weddings, sangeets, baby
              showers, birthdays, anniversaries and every celebration in
              between.
            </p>
          </div>
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-primary mb-6">
              Explore
            </p>
            <ul className="space-y-3 text-sm text-muted-foreground">
              {[
                ["About Us", "/about"],
                ["Gallery", "/gallery"],
                ["Packages", "/packages"],
                ["Testimonials", "/testimonials"],
                ["Book Now", "/booking"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="hover:text-primary transition-colors duration-300"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-primary mb-6">
              Connect
            </p>
            <a
              href="mailto:dream.entertainmentusa@gmail.com"
              data-testid="footer-email-link"
              className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
            >
              <Mail size={16} /> dream.entertainmentusa@gmail.com
            </a>
            <div className="flex gap-4 mt-6">
              {[
                {
                  icon: Instagram,
                  id: "instagram",
                  url: "https://www.instagram.com/dream.entertainmentusa",
                },
                {
                  icon: Facebook,
                  id: "facebook",
                  url: "https://www.facebook.com/people/Dream-Entertainment/61590468853545/",
                },
              ].map(({ icon: Icon, id, url }) => (
                <a
                  key={id}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={id}
                  data-testid={`footer-social-${id}`}
                  className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/40 transition-colors duration-300"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-16 flex flex-col sm:flex-row justify-between gap-4 text-xs text-muted-foreground/60 tracking-wider">
          <p>© {new Date().getFullYear()} Dream Entertainment. All rights reserved.</p>
          <p>Every beat. Every moment. Unforgettable.</p>
        </div>
      </div>
    </footer>
  );
}
